var map = {
	"./bg-layer-0.png": 3084,
	"./contact-us.png": 6291,
	"./customers/BrooklynSimmons.png": 1296,
	"./customers/LeslieAlexander.png": 7994,
	"./customers/WadeWarren.png": 404,
	"./evening-specials.png": 187,
	"./header-bg.png": 7997,
	"./ldn-ec1y-8jl.jpg": 7014,
	"./ldn-ec2y-9ap.jpg": 99,
	"./logo-only.png": 1992,
	"./logo.png": 7179,
	"./map.png": 2830,
	"./menu/1.png": 6119,
	"./menu/2.png": 5436,
	"./menu/3.png": 7061,
	"./menu/4.png": 8650,
	"./menu/5.png": 8483,
	"./menu/6.png": 6504,
	"./menu/7.png": 4897,
	"./menu/8.png": 6118,
	"./menu/takeaway/image001.png": 3012,
	"./menu/takeaway/image002.png": 7503,
	"./menu/takeaway/image003.png": 8486,
	"./menu/takeaway/image004.png": 7881,
	"./menu/takeaway/image005.png": 1632,
	"./menu/takeaway/image006.png": 2923,
	"./menu/takeaway/image007.png": 1794,
	"./menu/takeaway/image008.png": 9973,
	"./menu/takeaway/image009.png": 3436,
	"./menu/takeaway/image010.png": 4690,
	"./menu/takeaway/image011.png": 6235,
	"./menu/takeaway/image012.png": 8672,
	"./menu/takeaway/image013.png": 2873,
	"./menu/takeaway/image014.png": 2902,
	"./menu/takeaway/image015.png": 6703,
	"./menu/takeaway/image016.png": 1428,
	"./menu/takeaway/image017.png": 4669,
	"./menu/takeaway/image018.png": 1786,
	"./menu/takeaway/image019.png": 1619,
	"./menu/takeaway/image020.png": 5939,
	"./menu/takeaway/image021.png": 8362,
	"./menu/takeaway/image022.png": 8529,
	"./menu/takeaway/image023.png": 664,
	"./menu/takeaway/image024.png": 5831,
	"./menu/takeaway/image025.png": 7518,
	"./menu/takeaway/image026.png": 4869,
	"./menu/takeaway/image027.png": 5772,
	"./menu/takeaway/image028.png": 9931,
	"./menu/takeaway/image029.png": 5714,
	"./menu/takeaway/image030.png": 5688,
	"./menu/takeaway/image031.png": 305,
	"./menu/takeaway/image032.png": 1322,
	"./menu/takeaway/image033.png": 179,
	"./menu/takeaway/image034.png": 6572,
	"./menu/takeaway/image035.png": 5989,
	"./menu/takeaway/image036.png": 7838,
	"./menu/takeaway/image037.png": 7207,
	"./menu/takeaway/image038.png": 320,
	"./menu/takeaway/image039.png": 7225,
	"./menu/takeaway/image040.png": 2985,
	"./menu/takeaway/image041.png": 4864,
	"./menu/takeaway/image042.png": 6843,
	"./menu/takeaway/image043.png": 2018,
	"./menu/takeaway/image044.png": 6877,
	"./menu/takeaway/image045.png": 2980,
	"./menu/takeaway/image046.png": 9839,
	"./menu/takeaway/image047.png": 521,
	"./menu/takeaway/image048.png": 209,
	"./menu/takeaway/image049.png": 9992,
	"./menu/takeaway/image050.png": 8894,
	"./menu/takeaway/image051.png": 2039,
	"./menu/takeaway/image052.png": 4460,
	"./menu/takeaway/image053.png": 373,
	"./menu/takeaway/image054.png": 9946,
	"./menu/takeaway/image055.png": 1859,
	"./menu/takeaway/image056.png": 6248,
	"./menu/takeaway/image057.png": 7377,
	"./menu/takeaway/image058.png": 9510,
	"./menu/takeaway/image059.png": 1055,
	"./menu/takeaway/image060.png": 6367,
	"./menu/takeaway/image061.png": 2566,
	"./menu/takeaway/image062.png": 4333,
	"./menu/takeaway/image063.png": 1092,
	"./menu/takeaway/image064.png": 5899,
	"./menu/takeaway/image065.png": 4354,
	"./menu/takeaway/image066.png": 2537,
	"./menu/takeaway/image067.png": 8336,
	"./menu/takeaway/image068.png": 8919,
	"./menu/takeaway/image069.png": 3134,
	"./menu/takeaway/image070.png": 3524,
	"./menu/takeaway/image071.png": 4653,
	"./menu/takeaway/image072.png": 7238,
	"./menu/takeaway/image073.png": 5983,
	"./menu/takeaway/image074.png": 112,
	"./menu/takeaway/image075.png": 5865,
	"./menu/takeaway/image076.png": 1858,
	"./menu/takeaway/image077.png": 5515,
	"./menu/takeaway/image078.png": 5212,
	"./menu/takeaway/image079.png": 2725,
	"./menu/takeaway/image080.png": 4181,
	"./menu/takeaway/image081.png": 2556,
	"./menu/takeaway/image082.png": 9591,
	"./menu/takeaway/image083.png": 3806,
	"./menu/takeaway/image084.png": 2017,
	"./menu/takeaway/image085.png": 9976,
	"./menu/takeaway/image086.png": 1955,
	"./menu/takeaway/image087.png": 2122,
	"./menu/takeaway/image088.png": 5005,
	"./menu/takeaway/image089.png": 1764,
	"./menu/takeaway/image090.png": 8730,
	"./menu/takeaway/image091.png": 9491,
	"./menu/takeaway/image092.png": 5000,
	"./menu/takeaway/image093.png": 7713,
	"./menu/takeaway/image094.png": 4622,
	"./menu/takeaway/image095.png": 4615,
	"./menu/takeaway/image096.png": 5884,
	"./menu/takeaway/image097.png": 3397,
	"./menu/takeaway/image098.png": 2530,
	"./menu/takeaway/image099.png": 6187,
	"./menu/takeaway/image100.png": 6012,
	"./menu/takeaway/image101.png": 2549,
	"./menu/takeaway/image102.png": 8542,
	"./menu/takeaway/image103.png": 7767,
	"./menu/takeaway/image104.png": 5128,
	"./pham-specials.png": 947,
	"./pham.png": 9220,
	"./reservation.png": 3086,
	"./special-sashimi.png": 2914,
	"./sushi-1.png": 8880,
	"./sushi-bar.png": 4658,
	"./sushi-sashimi.png": 1585,
	"./top-left-corner.png": 4109,
	"./we-are-1.jpg": 7509,
	"./we-are-2.jpg": 7610,
	"./we-are-3.jpg": 3447,
	"./we-are-4.jpg": 7452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8756;